import { render, staticRenderFns } from "./PersonIdentification.vue?vue&type=template&id=57c2362d&scoped=true"
import script from "./PersonIdentification.vue?vue&type=script&lang=js"
export * from "./PersonIdentification.vue?vue&type=script&lang=js"
import style0 from "./PersonIdentification.vue?vue&type=style&index=0&id=57c2362d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c2362d",
  null
  
)

export default component.exports